<template>
  <div style="width: 100%; height: 100%">
    <van-nav-bar
      :title="$route.query.name"
      @click-left="onClickLeft"
      left-arrow
    />

    <div id="div_viewpoint" style="top: 100%"></div>

    <div id="MyViewerDiv"></div>

    <van-popup v-model="dialogShow" style="width:85%">
      <div style="padding: 20px;">
        <van-form validate-first @submit="onFailed">
          <van-field
            v-model="formName"
            name="pattern"
            placeholder="请选择类型"
            @click="typeShow = true"
            label="选择类型"
            input-align="right"
            :rules="[{ required: true, message: '' }]"
            readonly
            is-link
          />
          <van-field
            v-model="form.mobl08"
            name="pattern"
            placeholder="请输入链接"
            label="链接地址"
            input-align="right"
            :rules="[{ required: true, message: '' }]"
            is-link
            v-if="form.lbst03 == 2"
          />
          <van-field
            name="pattern"
            v-if="form.lbst03 == 1"
            placeholder="请选择类型"
            label="全景"
            input-align="right"
          >
            <template #input>
              <van-checkbox
                v-model="checkbox"
                v-if="form.lbst03 == 1"
                shape="square"
                >是/否</van-checkbox
              >
            </template>
          </van-field>
          <van-field
            v-model="form.mobl04"
            name="mobl04"
            placeholder="请输入名称"
            label="名称"
            input-align="right"
          />
          <van-field
            v-model="form.mobl05"
            name="mobl05"
            placeholder="请输入拍摄地点"
            label="拍摄地点"
            input-align="right"
            :rules="[{ required: true, message: '' }]"
          />
          <van-field
            v-model="form.mobl06"
            name="mobl06"
            placeholder="请选择拍摄时间"
            @click="showCalendar = true"
            label="拍摄时间"
            readonly
            is-link
            input-align="right"
            :rules="[{ required: true, message: '' }]"
          />
          <div style="width: 100%; margin: 10px auto" v-if="form.lbst03 == 1">
            <van-uploader
              v-model="fileList"
              :after-read="addfile"
              :max-count="1"
            />
          </div>
          <div style="width: 100%; margin: 10px auto" v-if="form.lbst03 == 3">
            <VideoRecorder
              ref="videoRecorder"
              title="录制或上传视频"
              :max-duration="30000"
              :allow-download="true"
              :show-instructions="true"
              :default-camera="'environment'"
              @recording-complete="onRecordingComplete"
              @file-selected="onFileSelected"
            />
          </div>

          <van-button type="info" native-type="submit" style="width: 100%"
            >提交</van-button
          >
        </van-form>
      </div>
    </van-popup>
    <van-calendar v-model="showCalendar" @confirm="onConfirmcalendar" />
    <van-popup v-model="typeShow" position="bottom" :style="{ height: '40%' }">
      <van-picker
        title="类型"
        show-toolbar
        :columns="labelData"
        @confirm="onConfirmlabel"
        value-key="Name"
      />
    </van-popup>

    <van-popup v-model="showVideo" @click="showVideo = false" style="width:90%">
      <div style="padding: 20px;height: 300px;">
        <video
          id="video"
          width="100%"
          height="100%"
          :src="videoUrl"
          controls
          autoplay
          muted
        ></video>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {
  FindWorkPlaneModel,
  GetViewPointUser,
  GetViewPoint,
  GetModelInfo,
  GetModelLableList,
  GetModelLableSets,
  UploadModelLable,
} from "@/api";
import VideoRecorder from "@/components/VideoRecorder/VideoRecorder.vue";
import { mapGetters } from "vuex";
export default {
  components: { VideoRecorder },
  data() {
    return {
      model: {},
      isShow: false,
      sousuo: "",
      modelid: "",
      uid: "",
      videoUrl: "",
      PointList: [],
      UserList: [],
      markup: null,
      btnShow: false,
      dialogShow: false,
      showCalendar: false,
      showVideo: false,
      typeShow: false,
      checkbox: false,
      formName: "",
      form: {
        mobl02: "",
        lbst03: 1,
        mobl03: "",
        mobl04: "",
        mobl05: null,
        mobl06: null,
        mobl07: 0,
        mobl08: null,
        mobl09: null,
        mobl10: null,
        mobl11: null,
        mobl12: null,
        mobl13: "",
        qid: "",
        file: null,
      },
      fileList: [],
      labelData: [],
    };
  },
  computed: {
    ...mapGetters(["qid", "pid"]),
  },
  methods: {
    onRecordingComplete(data) {
      console.log("录制完成:", data);
      this.form.file = data.file;
    },
    onFileSelected(data) {
      this.form.file = data.file;
    },
    addfile(file) {
      this.form.file = file.file;
    },
    onConfirmlabel(v) {
      if (v.lbst03 != 2) {
        this.form.mobl08 = "";
      }
      if (v.lbst03 != 1) {
        this.form.mobl07 = 0;
      }
      this.formName = v.Name;
      this.form.mobl03 = v.lbst01;
      this.form.lbst03 = v.lbst03;
      this.typeShow = false;
    },
    onConfirmcalendar(date) {
      this.form.mobl06 = `${date.getFullYear()}-${date.getMonth() +
        1}-${date.getDate()}`;
      this.showCalendar = false;
    },
    sousuoInput(el) {
      if (el) {
        this.PointList = this.PointList.filter(
          (v) => v.vipo02.indexOf(el) != -1
        );
      } else {
        this.getPointData(this.uid);
      }
    },
    showTool() {
      this.markup.leaveEditMode();
      this.markup.hide();
      EaBIM.view.unloadExtension("Autodesk.Viewing.MarkupsCore");
      this.markup = null;
      this.btnShow = false;
    },
    showUserPoint(item) {
      this.getPointData(item.user01);
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    // 模型初始化显示
    showModel(data) {
      data.enterType = "sj";
      EaBIM.localServerModels(data);
      this.GetModelLableListFC();
    },
    GetModelLableListFC() {
      let params = {
        xid: this.$store.state.pid || localStorage.xid,
        modelId: this.$route.query.wopl06,
        type: 0,
        searchword: "",
        pageIndex: 1,
        pageSize: 9999,
      };
      GetModelLableList(params).then((res) => {
        EaBIM.lableLoad(res.Data.list);
      });
    },
    showPoint(item) {
      var _this = this;
      var json = item.vipo06.replace(/'/g, '"');
      var jsonObject = JSON.parse(json);
      if (EaBIM.view.restoreState(jsonObject)) {
        EaBIM.view
          .loadExtension("Autodesk.Viewing.MarkupsCore")
          .then((markupM) => {
            _this.markup = markupM;
            _this.markup.load();
            // markupM.enterEditMode();
            var markup = item.vipo07;
            setTimeout(() => {
              _this.markup.show();
              if (markup && markup.replace(/(^\s*)|(\s*$)/g, "").length > 0) {
                var markupList = markup.split("@#@");
                if (markupList != null && markupList.length > 0) {
                  for (var i = 0, l = markupList.length; i < l; i++) {
                    var singleMarkup = markupList[i].split("@BIM@");
                    _this.markup.loadMarkups(
                      singleMarkup[1].replace(/'/g, '"'),
                      singleMarkup[0]
                    );
                  }
                }
              }
            }, 500);
          });
      }
      this.isShow = false;
      this.btnShow = true;
    },
    // 模型详情
    async GetModelInfo(id) {
      let res = await FindWorkPlaneModel({ id });
      this.showModel(res.Data);
      this.modelid = res.Data.modelId;
      this.getPointData();
      this.getPointUser();
    },
    async getPointData(uid) {
      let res = await GetViewPoint({
        modelid: this.modelid,
        modeltype: 1,
        selectId: "",
        userId: uid || "",
      });
      this.uid = uid;
      this.PointList = res.Data.filter((v) => v.vipo10 == 0);
    },
    async getPointUser() {
      let res = await GetViewPointUser({
        params: {
          id: this.modelid,
        },
      });
      this.UserList = res.Data;
    },
    viewers(url) {
      var Params = this.locationParams,
        _this = this;
      //初始化
      var config = {
        extensions: [
          "Autodesk.Viewing.ZoomWindow",
          // "Autodesk.Viewing.Collaboration",
        ],
        disabledExtensions: {
          measure: false,
          section: false,
        },
        memory: {
          limit: 32 * 1024, //32 GB
        },
      };
      var myViewerDiv = document.getElementById("MyViewerDiv");
      _this.viewer = new Autodesk.Viewing.Private.GuiViewer3D(
        myViewerDiv,
        config
      );
      var options = {
        document: url,
        language: "zh-HANS",
        env: "Local",
        offline: "true",
        useADP: false,
      };
      Autodesk.Viewing.Initializer(options, function onInitialized() {
        _this.viewer.start();
        _this.viewer.loadModel(options.document, {
          isAEC: true,
        });
        _this.viewer.setTheme("light-theme");
        _this.viewer.addEventListener(
          Autodesk.Viewing.TEXTURES_LOADED_EVENT,
          function(event) {
            //选择集
            var json = Params.state.replace(/'/g, '"');
            var jsonObject = JSON.parse(json);
            _this.viewer.restoreState(jsonObject);
          }
        );
      });
    },
    openDialog(id) {
      var selSet = EaBIM.view.getSelection(),
        fragId = "";
      if (!selSet.length) {
        this.$message({
          type: "error",
          message: "请选择关联构件",
        });
        return;
      }
      var it = EaBIM.view.model.getData().instanceTree;
      it.enumNodeFragments(
        selSet[0],
        function(id) {
          fragId = id;
        },
        false
      );
      this.form.mobl09 = this.$route.query.wopl06;
      this.form.mobl10 = id;
      this.form.mobl11 = fragId;
      this.form.mobl12 = JSON.stringify(EaBIM.view.getState());
      this.dialogShow = true;
    },
    async onFailed() {
      if (this.form.mobl04 == "" || !this.form.mobl04) {
        this.$Toast.fail("请输入名称");
        return false;
      }
      this.form.mobl02 = this.$store.state.pid;
      this.form.mobl13 = this.$store.state.uid;
      this.form.qid = this.$store.state.qid;
      this.form.mobl07 = this.checkbox ? 1 : 0;
      if (this.form.lbst03 == 2) {
        delete this.form.file;
      } else if (this.form.lbst03 !== 2) {
        if (this.form.file == null) {
          this.$Toast.fail(this.form.lbst03 == 1 ? "请选择图片" : "请选择视频");
          return false;
        }
      }
      var formData = new FormData();
      for (const key in this.form) {
        formData.append(key, this.form[key]);
      }
      let res = await UploadModelLable(formData);
      console.log(res);
      res.Code > 0 ? this.$Toast("成功") : this.$Toast("失败");
      this.form = this.$options.data().form;
      this.fileList = this.$options.data().fileList;
      this.checkbox = false;
      this.dialogShow = false;
      this.GetModelLableListFC();
    },
    getLableSets() {
      let params = {
        xid: this.$store.state.pid,
      };
      GetModelLableSets({ params }).then((res) => {
        this.form.mobl03 = res.Data[0].lbst01;
        this.form.lbst03 = res.Data[0].lbst03;
        this.formName = res.Data[0].Name;
        this.labelData = res.Data;
      });
    },
    showImage(item) {
      console.log(item);
      if (item.lbst03 == 1) {
        this.$ImagePreview([this.$store.state.baseUrl + item.mobl08]);
      } else if (item.lbst03 == 2) {
        window.open(item.mobl08);
      } else {
        this.showVideo = true;
        this.videoUrl = this.$store.state.baseUrl + item.mobl08;
        // this.$ImagePreview([this.$store.state.baseUrl + item.mobl08]);
      }
    },
  },
  mounted() {
    let _this = this;
    function observe(el, options, callback) {
      var MutationObserver =
        window.MutationObserver ||
        window.WebKitMutationObserver ||
        window.MozMutationObserver;
      var observer = new MutationObserver(callback);
      observer.observe(el, options);
    }
    var text = document.getElementById("div_viewpoint");
    var options = {
      childList: true,
      subtree: true,
      attributes: true,
      attributeOldValue: true,
      characterData: true,
    };
    observe(text, options, (records, instance) => {
      records.map((record) => {
        _this.isShow = record.oldValue.includes("none");
      });
    });
    if (this.$route.query.modelId) {
      let params = {
        modelId: this.$route.query.modelId,
        mtype: "",
      };
      GetModelInfo(params).then((res) => {
        if (res.Code != 1) {
          this.$Toast(res.Message);
          return;
        }
        EaBIM.modelData.modelId = this.$route.query.modelId;
        this.viewers(this.$store.state.baseUrl + res.Data.mode09);
      });
    }
  },
  created() {
    window.VueThis = this;
    window.viewThisLable = this.showImage;
    if (this.$route.query.id) {
      this.GetModelInfo(this.$route.query.id);
    }
    this.getLableSets();
  },
};
</script>

<style lang="scss" scoped>
.popDiv {
  height: 540px;
  width: 100%;
  overflow: auto;
  padding: 5px;
}

#MyViewerDiv {
  height: 100%;
  width: 100%;
  position: absolute;
}

.markcircle {
  position: relative;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  top: 100px;
  left: 0;
  background-color: rgb(31, 147, 255);
  box-shadow: 0 0 6px 1px #fff;
}

.pointDiv {
  border-radius: 10px;
  min-height: 80px;
  padding: 0 40px;
  box-shadow: 0 0 8px 5px rgb(238, 238, 238);
  margin: 20px 0;
}

.marklabel {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: rgb(31, 147, 255);
  position: absolute;
  top: 65px;
  left: -56px;
  z-index: -1;
}

.markwire2 {
  position: absolute;
  top: -54px;
  left: 3px;
  width: 40px;
  height: 2px;
  box-shadow: 0 0 6px 1px #fff;
  z-index: 1;
  background-color: rgb(31, 147, 255);
  transform: rotate(-30deg);
}

.userImg {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: rgb(0, 89, 255);
  text-align: center;

  img {
    width: 80%;
    height: 80%;
  }

  line-height: 80px;
  color: white;
  font-size: 32px;
}

/deep/ #EaBIM_button_2D,
/deep/ #EaBIM_button_versions,
/deep/ #EaBIM_button_crashCheck,
/deep/ #EaBIM_button_filter,
/deep/ #EaBIM_button_selectWindow,
/deep/ #toolbar-fullscreenTool,
/deep/ #toolbar-modelStructureTool,
/deep/ #toolbar-explodeTool,
/deep/ #toolbar-levelsTool,
/deep/ #toolbar-measurementSubmenuTool {
  display: none;
}

.markwire {
  position: absolute;
  top: -23px;
  width: 44px;
  left: -17px;
  box-shadow: 0 0 6px 1px #fff;
  height: 2px;
  background-color: rgb(31, 147, 255);
  transform: rotate(-90deg);
}

.markframe {
  position: relative;
  box-sizing: border-box;
  /* font-size: 12px; */
  /* line-height: 1.5; */
  border-width: 2px;
  border-style: solid;
  border-color: rgb(31, 147, 255);
  background-color: rgb(238, 238, 238);
  opacity: 0.8;
  /* width: 160px;
  height: 40px; */
  width: 85px;
  height: 30px;
  left: 40px;
  top: -77px;
  cursor: pointer;
  /* overflow-x: hidden;
    overflow-y: auto; */
  overflow: hidden;
  border-radius: 5px;

  font-size: 16px;
  line-height: 25px;
  padding: 0px 2px;
  color: black;
}

.markframe img {
  height: 40px;
  width: 40px;
  display: block;
  float: left;
}

.markframe div {
  height: 100%;
  /* overflow: auto; */
  padding: 0px 2px;
  color: black;
}

.markframe div p {
  font-size: 16px;
  line-height: 40px;
}
</style>
